
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import GlobalState from '@/util/GlobalState';
import User from '@/api/mjegb/User';

@Component
export default class UserDisplay extends Vue {
    @Prop({ required: false, type: Boolean, default: false }) public readonly compactOnMobile!: boolean;

    public get loading(): boolean {
        return !this.user;
    }

    public get user(): User | null {
        return this.globalState?.currentUser || null;
    }

    @Inject()
    private readonly globalState!: GlobalState;

    public onNavigateToLogin(): void {
        this.globalState.beginLogin();
    }

    public onLogout(): void {
        this.globalState.beginLogout();
    }
}
